import React from 'react';
import { useTranslation } from 'react-i18next';
import BottomNav from '../components/BottomNav';
import PrayerTextSection from '../components/PrayerTextSection';
import RabbiSpecialRecordingUI from '../components/RabbiSpecialRecordingUI';
import { useTraditionRabbi } from '../utils/rabbiesFirestore';
import { getRabbiSpecialAudioUrl } from '../components/utils';
import shemaData from '../../data/shema.json';
import type { PrayerTextData } from '../components/PrayerTextSection';

const TEXT_DARK = '#1A1A2E';
const BORDER_LIGHT = '#D1D5DB';

const ShemaPage: React.FC = () => {
  const { t, i18n } = useTranslation();
  const isHebrew = i18n.language?.startsWith('he');
  const direction = 'rtl';
  const rabbi = useTraditionRabbi('parasha');
  const isRabbi = typeof localStorage !== 'undefined' && !!localStorage.getItem('rabbiToken');

  return (
    <div
      style={{
        flex: 1,
        minHeight: 0,
        overflow: 'hidden',
        background: '#f9fafb',
        fontFamily: "var(--kol-font-sans, 'Inter', system-ui, sans-serif)",
        color: TEXT_DARK,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          padding: '18px 18px 110px',
          boxSizing: 'border-box',
          direction,
          flexGrow: 1,
          overflowY: 'auto',
        }}
      >
        {isRabbi && (
          <div
            style={{
              background: 'white',
              borderRadius: 16,
              padding: 16,
              marginBottom: 18,
              border: `1px solid ${BORDER_LIGHT}`,
              boxShadow: '0 4px 12px rgba(0,0,0,0.06)',
            }}
          >
            <div
              style={{ fontSize: 16, fontWeight: 700, color: TEXT_DARK, marginBottom: 12 }}
              dir="rtl"
            >
              {t('rabbi_upload_record_here', 'Record here (see text below)')}
            </div>
            <RabbiSpecialRecordingUI type="shema" />
          </div>
        )}

        <PrayerTextSection
          data={shemaData as PrayerTextData}
          titleTKey="user_portal_shema_section"
          rabbiAudioUrl={
            rabbi
              ? getRabbiSpecialAudioUrl(
                  'shema',
                  rabbi.tradition?.toLowerCase() || 'ashkenaz',
                  rabbi.key || rabbi.id,
                )
              : null
          }
          direction={direction}
          isHebrew={isHebrew}
        />
      </div>
      <BottomNav />
    </div>
  );
};

export default ShemaPage;
